/* Aventurx — promozioni: conto alla rovescia (snippets/axr-promo-countdown.liquid).
   Date "2026-10-24 00:00" o "24/10/2026 00:00", lette nell'ora del dispositivo del cliente. */
(function () {
  if (window.axrPromo) return;
  window.axrPromo = true;

  function parse(str) {
    if (!str) return null;
    var s = String(str).trim();
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:.](\d{2}))?$/.exec(s);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0);
    m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2})[:.](\d{2}))?$/.exec(s);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0), 0);
    return null;
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var timers = [];
  function setup(el) {
    if (el.dataset.cdReady) return;
    el.dataset.cdReady = '1';
    var start = parse(el.dataset.start);
    var end = parse(el.dataset.end);
    if (!start && !end) return;
    var label = el.querySelector('[data-cd-label]');
    var units = el.querySelector('[data-cd-units]');
    var parts = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { parts[k] = el.querySelector('[data-cd="' + k + '"]'); });

    function tick() {
      var now = new Date();
      var target = null;
      var state;
      if (start && now < start) { target = start; state = 'before'; }
      else if (end && now < end) { target = end; state = 'during'; }
      else if (end) { state = 'after'; }
      else { el.hidden = true; return false; }
      el.hidden = false;
      el.dataset.state = state;
      label.textContent = el.dataset['label' + state.charAt(0).toUpperCase() + state.slice(1)] || '';
      if (!target) { units.hidden = true; return false; }
      units.hidden = false;
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      parts.d.textContent = pad(Math.floor(diff / 86400));
      parts.h.textContent = pad(Math.floor(diff % 86400 / 3600));
      parts.m.textContent = pad(Math.floor(diff % 3600 / 60));
      parts.s.textContent = pad(diff % 60);
      return true;
    }
    if (tick()) timers.push(tick);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-axr-countdown]').forEach(setup);
  }
  setInterval(function () {
    for (var i = timers.length - 1; i >= 0; i--) { if (!timers[i]()) timers.splice(i, 1); }
  }, 1000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  // editor del tema: sezioni ricaricate
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
